import { AppBar, Box, Button, Chip, Toolbar, useMediaQuery, Drawer, useTheme } from '@mui/material';
import headerStyles from './Header.styles';
import { useLocation } from 'react-router-dom';
import finvuLogo from '../../assets/finvuLogoNew.png';
import helpIcon from '../../assets/help.svg';
import CloseIcon from "@mui/icons-material/Close";
import AuthApis from '../../hepler/authApis.service';
import DialogBox from '../Dialog Box/Dialog Box';
import CancelConsent from '../Accounts/CancelConsent';
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import StepperBar from './Stepper';
import StepperInfoDialog from './StepperInfoDialog';
import SelectLang from './SelectLang';
import { withTranslation } from '../../hoc/withTranslation';

function Header(props) {
	const theme = useTheme();
	const { t } = props;
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));
	
	// Check for dark theme
	const isDark = props.customDetails?.darkTheme === true || theme.palette.mode === 'dark';
	const authApis = new AuthApis();
	const [openDialog, setOpenDialog] = useState(false);
	const [openMultiLang, setOpenMultiLang] = useState(false);
	const [showInfoDialog, setShowInfoDialog] = useState(false);
	const [hideStepper, setHideStepper] = useState(false);
	const history = useHistory();
	const handleCancel = () => {
		setOpenDialog(false);
		history.push({
			pathname: `/consent-status`,
			state: {
				status: 'Consent denied',
				statusCode: authApis.handleCancelTermination("cancel"),
			},
		});
	}
	const location = useLocation();
	const currentPath = location.pathname;
	const isVoiceJourney = location.pathname.includes('voice-journey') || location?.state?.type === 'voice journey';
	
	// Allow login page to open the SelectLang modal via custom event
	useEffect(() => {
		const handler = () => setOpenMultiLang(true);
		window.addEventListener('finvu:openSelectLang', handler);
		return () => window.removeEventListener('finvu:openSelectLang', handler);
	}, []);

	// Listen for changes to global.showingFilteredAccountNotFound
	useEffect(() => {
		const handleStepperVisibilityChange = () => {
			setHideStepper(!!global.showingFilteredAccountNotFound);
		};
		
		// Check immediately
		handleStepperVisibilityChange();
		
		// Listen for custom event
		window.addEventListener('stepperVisibilityChange', handleStepperVisibilityChange);
		
		return () => {
			window.removeEventListener('stepperVisibilityChange', handleStepperVisibilityChange);
		};
	}, [currentPath]);
	
	// Hide close icon on FilteredAccountNotFound screen (targeted discovery with no accounts)
	const isFilteredAccountNotFoundScreen = global.showingFilteredAccountNotFound;
	const isLoginPage = /^(\/$|\/login\/?([^/]+)?$)/.test(location.pathname);
	
	const shouldShowIcon = (location.pathname.includes('home') || location.pathname.includes('accounts')) && 
		!isFilteredAccountNotFoundScreen;
	const shouldShowCloseIcon = shouldShowIcon || isLoginPage;
	const handleCloseClick = () => {
		if (isLoginPage) {
			window.dispatchEvent(new Event('finvu:openExitConfirm'));
			return;
		}
		setOpenDialog(true);
	};
	
	const isConsentStatusPage = /^\/consent-status\/?$/.test(location.pathname);
	const isConsentRenewalPage = location.pathname.includes('consent-renew');
	const isConsentRenewalStatusPage = location.pathname.includes('consent-renew-status');
	const isConsentRenewalFlow = isConsentRenewalPage || isConsentRenewalStatusPage || (isLoginPage && global.renewConsentId);
	const showLoginHeaderActions = isLoginPage && global.isRedirect === 'true';
	const handleClose = (event, reason) => {
		setOpenDialog(false);
	};
	const closeMultiLang = () => {
		setOpenMultiLang(false)
	};
	const showStepper =
		/^\/$/.test(currentPath) ||                             
		/^\/home\/?$/.test(currentPath) ||                     
		/^\/login\/?([^/]+)?$/.test(currentPath) ||             
		/^\/accounts\/[^/]+\/?([^/]+)?$/.test(currentPath) ||  
		/^\/payment-consent\/?$/.test(currentPath) ||          
		/^\/NoAccountFound\/[^/]+$/.test(currentPath);  
	return (
		<Box sx={{
			...headerStyles.container,
			backgroundColor: isDark ? '#161616' : 'transparent',
			color: isDark ? '#FFFFFF' : '#000000'
		}}>
			<AppBar sx={{
				...headerStyles.appBar, 
				background: isDark ? '#161616' : theme.palette.background.default,
				color: isDark ? '#FFFFFF' : '#000000'
			}}>
				<Toolbar sx={{
					...headerStyles.p0,
					backgroundColor: isDark ? '#161616' : 'transparent',
					width: '100%',
					minHeight: 'auto',
				}}>
					<Box sx={headerStyles.imageBox}>
						{(props.customDetails?.logo || props.customDetails?.subLogo) && (
							<Box
								sx={{
									...headerStyles.logoContainer,
									gap: '0.75rem',
								}}
							>
								{props.customDetails?.logo && !props.customDetails?.subLogo && (
									<>
										<img
											src={finvuLogo}
											alt="Finvu"
											style={{
												...headerStyles.logo,
												maxHeight: isMobile ? '2rem' : '2.5rem',
												maxWidth: isMobile ? '90px' : '120px',
												flexShrink: 0,
											}}
										/>
										<Box
											sx={{
												width: '1px',
												height: isMobile ? '1.5rem' : '2rem',
												backgroundColor: isDark ? 'rgba(255, 255, 255, 0.3)' : '#CCCCCC',
												flexShrink: 0,
											}}
										/>
									</>
								)}
								{props.customDetails?.logo && (
									<img
										src={props.customDetails.logo}
										alt="logo"
										style={{
											...headerStyles.logo,
											maxHeight: isMobile ? '2rem' : '2.5rem',
											maxWidth: isMobile ? '100px' : '140px',
										}}
									/>
								)}
								{props.customDetails?.subLogo && (
									<>
										{props.customDetails?.logo && (
											<Box
												sx={{
													width: '1px',
													height: isMobile ? '1.5rem' : '2rem',
													backgroundColor: isDark ? 'rgba(255, 255, 255, 0.3)' : '#CCCCCC',
													flexShrink: 0,
												}}
											/>
										)}
										<img
											src={props.customDetails.subLogo}
											alt="sub logo"
											style={{
												...headerStyles.subLogo,
												maxHeight: isMobile ? '2rem' : '2.5rem',
												maxWidth: isMobile ? '100px' : '140px',
											}}
										/>
									</>
								)}
							</Box>
						)}
						<Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
								{global.showFaq && (!isLoginPage || showLoginHeaderActions) && (
									<Chip
										size="small"
										icon={<img src={helpIcon} alt="" style={{ width: 13, height: 13, marginLeft: 6 }} />}
										label="FAQs"
										variant="outlined"
										onClick={() => window.dispatchEvent(new Event('finvu:openFaq'))}
										sx={{ fontSize: '0.75rem', color: isDark ? '#FFFFFF' : 'inherit', borderColor: isDark ? 'rgba(255,255,255,0.4)' : '#CCCCCC', flexShrink: 0 }}
									/>
								)}
								{global.sdkOptions?.allowSelectLang === 'true' && (!isLoginPage || showLoginHeaderActions) && !isConsentRenewalFlow && !isVoiceJourney && (
									<Chip
										size="small"
										label="Aa/अ"
										variant="outlined"
										onClick={() => setOpenMultiLang(true)}
										sx={{ fontSize: '0.75rem', color: isDark ? '#FFFFFF' : 'inherit', borderColor: isDark ? 'rgba(255,255,255,0.4)' : '#CCCCCC', flexShrink: 0 }}
									/>
								)}
								{shouldShowCloseIcon && (
									<Chip
										size="small"
										label={<CloseIcon sx={{ fontSize: 14 }} />}
										variant="outlined"
										onClick={handleCloseClick}
										sx={{
											width: 24,
											height: 24,
											borderRadius: '50%',
											flexShrink: 0,
											color: isDark ? '#FFFFFF' : 'inherit',
											borderColor: isDark ? 'rgba(255,255,255,0.4)' : '#CCCCCC',
											'& .MuiChip-label': { padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' },
										}}
									/>
								)}
						</Box>
					</Box>
				</Toolbar>
			</AppBar>
		{showStepper && !isLoginPage && !isConsentStatusPage && !hideStepper && (
			<StepperBar
				customDetails={props.customDetails}
				onInfoClick={() => setShowInfoDialog(true)}
			/>
		)}
			<StepperInfoDialog
				open={showInfoDialog}
				onClose={() => setShowInfoDialog(false)}
				customDetails={props.customDetails}
				isMobile={isMobile}
				isDark={isDark}
			/>
			<DialogBox
				open={openDialog}
				handleClose={handleClose}
				title={t('header.dialog.cancelConsent.title')}
				subTitle={t('header.dialog.cancelConsent.subtitle')}
				boxPadding="1.5rem"
				subTitleMaxWidth="85%"
			>
				<CancelConsent
					handleCancel={handleClose}
					{...props}
					handleDeny={handleCancel}
				/>
			</DialogBox>
			{!isMobile ? 
			<DialogBox
			   open={openMultiLang}
			   handleClose={closeMultiLang} 
			   sx={{border: '2px solid black', display: { xs: 'none', sm: 'none', md: 'none' }}}
			   boxPadding='0'
			>
			   <SelectLang
			     handleCancel={closeMultiLang}
				 customDetails={props.customDetails}
			   />
			</DialogBox>
			:
			<Drawer
			   open={openMultiLang}
			   anchor="bottom"
			   onClose={closeMultiLang}
			   sx={{display: { xs: 'flex', sm: 'flex', md: 'none' }}}
			   PaperProps={{
					sx: {
						maxHeight: 'min(92dvh, 900px)',
						width: '100%',
						maxWidth: '100%',
						borderTopLeftRadius: 12,
						borderTopRightRadius: 12,
						overflow: 'hidden',
					},
				}}
			>
				<SelectLang
				 handleCancel={closeMultiLang}
				 customDetails={props.customDetails}
				/>
			</Drawer>
			}
		</Box>
	);
}

export default withTranslation(Header);
